import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import ImgResponsive from './ImgResponsive';

const ads1 = "/images/SQ_byd/SQ_byd-1.jpg";
const ads2 = "/images/SQ_byd/SQ_byd-2.jpg";
const ads3 = "/images/SQ_byd/SQ_byd-3.jpg";
const ads4 = "/images/SQ_byd/SQ_byd-4.jpg";
const ads5 = "/images/SQ_byd/SQ_byd-5.jpg";

const CarouselByd: React.FC = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Box sx={{ width: '98%', margin: '0 auto', padding: '10px 2px 2px 2px' }}>
      <Slider {...settings}>
        <div>
          <ImgResponsive src={ads1} alt="BYD E6 - Premium Electric MPV" />
        </div>
        <div>
          <ImgResponsive src={ads2} alt="BYD E6 Photos" />
        </div>
        <div>
          <ImgResponsive src={ads3} alt="Electric &amp; Premium - BYD E6" />
        </div>
        <div>
          <ImgResponsive src={ads4} alt="BYD E6 - Sofa Seat " />
        </div>
        <div>
          <ImgResponsive src={ads5} alt="BYD E6 - Luggage Space" />
        </div>
      </Slider>
    </Box>
  );
};

export default CarouselByd;
